import { Reveal, Eyebrow } from "./Reveal";
import { FACTS } from "../../data/site";

export const About = () => (
  <section id="about" data-testid="about-section" className="section bg-[var(--paper)]">
    <div className="mx-auto grid max-w-7xl gap-16 px-5 md:px-10 lg:grid-cols-12">
      <Reveal className="lg:col-span-7">
        <Eyebrow>About the firm</Eyebrow>
        <h2 className="section-title mt-4">Built in the field, on time</h2>
        <div className="mt-8 space-y-5 text-base leading-relaxed text-[var(--muted-ink)] md:text-lg">
          <p>Vata Infrastructures is a Bengaluru civil contracting firm founded in October 2018 by Darshan Bhaskar T. We work mostly in forests and wildlife areas, where sites are remote, the terrain is difficult and the work has to hold up against elephants and large cats.</p>
          <p>Our works are won by e-tender and certified on completion by the Karnataka Forest Department, Karnataka Neeravari Nigam Limited and Visvesvaraya Jala Nigam Limited. We handle the whole job: excavation, PCC and RCC, structural steel, masonry, fencing, hydro-mechanical gates, finishing and painting. Our own labour force is covered under EPF and ESI.</p>
        </div>
        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <div className="border-l-4 border-[var(--rust)] bg-white p-6" data-testid="about-how-we-win">
            <p className="font-mono text-xs uppercase tracking-wider text-[var(--rust)]">How we win work</p>
            <p className="mt-2 text-[var(--ink)]">Every contract is won by open e-tender with government departments.</p>
          </div>
          <div className="border-l-4 border-[var(--forest)] bg-white p-6" data-testid="about-how-we-deliver">
            <p className="font-mono text-xs uppercase tracking-wider text-[var(--forest)]">How we deliver</p>
            <p className="mt-2 text-[var(--ink)]">Each work is certified on completion by the department, with our own EPF and ESI covered crews.</p>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-5">
        <div className="relative">
          <img src="/img/fence-crew.jpg" alt="Our crew along a finished chain link fence" className="aspect-[4/3] w-full object-cover" />
          <span className="absolute -bottom-4 -left-4 bg-[var(--rust)] px-4 py-2 font-mono text-xs uppercase tracking-wider text-white">Our own crews</span>
        </div>
        <dl data-testid="company-facts" className="mt-12 divide-y divide-black/10 border-y border-black/10">
          {FACTS.map(([k, v]) => (
            <div key={k} className="grid grid-cols-3 gap-4 py-4">
              <dt className="font-mono text-xs uppercase tracking-wider text-[var(--muted-ink)]">{k}</dt>
              <dd className="col-span-2 font-semibold text-[var(--ink)]">{v}</dd>
            </div>
          ))}
        </dl>
      </Reveal>
    </div>
  </section>
);
